import { useMemo } from 'react';
import useColors from 'hooks/useColors';
import { useAppSelector } from 'store/hooks';
import useSectors from './useSectors';
import { selectPositions } from '../reducers/selectors';
const useInsightsData = (category) => {
    const colors = useColors();
    const { sectorInfoMap } = useSectors();
    const positions = useAppSelector(selectPositions);
    const categoryIdSectorMap = useAppSelector((state) => state.invest.categoryIdSectorMap);
    const data = useMemo(() => {
        if (!positions.length || !categoryIdSectorMap) {
            return { total: 0, data: [], count: 0, sliceIndexMap: {}, defaultSliceKey: '' };
        }
        switch (category) {
            case 'HOLDINGS': {
                let total = 0;
                const sliceIndexMap = {};
                const data = positions.map((position, index) => {
                    total += position.quantity;
                    sliceIndexMap[position.assetId] = index;
                    return {
                        hideIcon: true,
                        key: position.assetId,
                        value: position.quantity,
                        category: {
                            sector: position.sector,
                            iconUrl: position.iconUrl,
                            name: position.name ?? position.symbol,
                        },
                        selectedColor: colors.gradients.ultimate.colors[0],
                    };
                });
                return { total, data, count: data.length, sliceIndexMap, defaultSliceKey: data[0].key };
            }
            case 'SECTOR': {
                let total = 0;
                const sectorStockMap = {};
                positions.forEach((position) => {
                    total += position.quantity;
                    const { sector } = position;
                    const sectorInfo = sectorInfoMap[sector];
                    if (sectorInfo) {
                        sectorStockMap[sector] = {
                            key: sector,
                            value: (sectorStockMap[sector]?.value || 0) + position.quantity,
                            category: {
                                sector,
                                name: sector ?? position.symbol,
                                Icon: sectorInfo.Icon,
                                sectorId: position.categoryId,
                                gradientKey: sectorInfo.gradientKey,
                            },
                            selectedColor: sectorInfo.color.colors[1],
                        };
                    }
                });
                const data = Object.values(sectorStockMap);
                data.sort((b, a) => {
                    const amountA = a.value;
                    const amountB = b.value;
                    if (amountA !== undefined && amountB !== undefined) {
                        return amountA - amountB;
                    }
                    if (amountA !== undefined) {
                        return 1;
                    }
                    if (amountB !== undefined) {
                        return -1;
                    }
                    return 0;
                });
                const sliceIndexMap = {};
                data.forEach((sectorData, index) => {
                    sliceIndexMap[sectorData.key] = index;
                });
                return { total, data, count: data.length, sliceIndexMap, defaultSliceKey: data[0].key };
            }
            default:
                return { total: 0, data: [], count: 0, sliceIndexMap: {}, defaultSliceKey: '' };
        }
    }, [category, categoryIdSectorMap, colors.gradients.ultimate.colors, positions, sectorInfoMap]);
    return data;
};
export default useInsightsData;
